// Example presets specifically for the Front & Back Shoot workflow
export const frontBackExamplePresets = [
  {
    id: 1,
    name: 'Red Dress Shoot',
    frontPreview: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-workflow-front-back%2Fexample1%2Ffront.jpeg?alt=media&token=8000f56f-e861-4192-9074-b8148713e2d0',
    backPreview: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-workflow-front-back%2Fexample1%2Fback.jpeg?alt=media&token=4495d1c4-2d45-4cc6-b2a5-c7334f6eeaca',
    prompt: 'Professional photoshoot of a red dress in a bright studio with soft lighting',
    results: [
      'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/generated_image%2Fai_workflow%2FYqsl85WkdWellAJHbVgrZhu9lBS2%2Fbcbdb45b-ed0d-4db1-8726-2369b0047a2d%2F43809e70-d679-4a6b-9268-ffa64a85aea6?alt=media&token=af2ff11c-5088-4644-9876-f33a4892ffb0'
    ],
    /** When user clicks this example, preselect this model (by name) and jump to Summary */
    presetModelName: 'Ahilya',
    presetBackgroundId: 'mahal_017',
  }
];

export type FrontBackExamplePreset = typeof frontBackExamplePresets[0];
